import { Button, DialogActions } from '@material-ui/core'
import React, {Fragment, useEffect, useRef, useState} from 'react'
import { useSvgDrawing } from 'react-hooks-svgdrawing'
import { svgToPng } from '../../../utils/svgToPng'

const DrawSignature = ({show, download}) => {
    const mounted = useRef(false)

    const [renderRef, draw] = useSvgDrawing({
        penWidth: 3,
    })
    useEffect(() => {
        mounted.current && !show && download(draw.getSvgXML())
        if(show){
            mounted.current = true
            return
        }
    }, [show, download])

    return (
        <div data-intrcm-id="signature_ytp9htzn" style={{ backgroundColor: '#fff', width: 200, height: 200, marginRight: 'auto', marginLeft: 'auto' }} ref={renderRef} />
    )
}

export const Signature = ({signature, classes, t, isEditSignature, setIsEditSignature, updateSignature, getFixedSignature}) => {
    const [renderPic, setRenderPick]  = useState(isEditSignature)
    const [fixedSignature, setFixedSignature] = useState(signature)

    useEffect(()=> {
        const fixedSignature = signature && signature.includes("fileId=") ? getFixedSignature(signature) : signature
        setFixedSignature(fixedSignature)
    }, [signature])

    const handleEditSignature = () => {
        setIsEditSignature(true)
        setRenderPick(true)
    }
    const handleStopEditSignature = () => {
        setIsEditSignature(false)
    }
    const handleSave = () => {
        setRenderPick(false)
    }
    const handleDownload = async (svgString) => {
        const png = await svgToPng(svgString)
        updateSignature(png)
        handleStopEditSignature()
    }

    const CommonActions = !isEditSignature && (
        <Button onClick={handleEditSignature} aria-label="change" className={classes.button}>
            {fixedSignature ? t('Change') : t("Add")}
        </Button>
    )
    const EditActions = isEditSignature && (
        <Fragment>
            <Button onClick={handleSave} aria-label="save" className={classes.button}>
                {t('Save')}
            </Button>
            <Button onClick={handleStopEditSignature} aria-label="cancel" className={classes.button}>
                {t('Cancel')}
            </Button>
        </Fragment>
    )
    const ImageSign = fixedSignature && !isEditSignature && (
        <img style={{display: 'block', marginRight: 'auto', marginLeft: 'auto'}} width={75} height={75} src={fixedSignature}/>
    )
    const DrawSign = isEditSignature && (
        <div data-intrcm-id="signature_9ip9v9mj" style={{paddingTop: 20}}>
           <DrawSignature show={renderPic} download={handleDownload}/>
        </div>
    )
    const Footer = !fixedSignature && !isEditSignature &&  <div data-intrcm-id="signature_988yg6ik" style={{height: 75}}/>
    return (
    <Fragment>
        <div data-intrcm-id="signature_61b4vnh2" style={{ backgroundColor: 'rgba(241,240,239,1)', width: '100%', height: isEditSignature ? 240 : 75 }}>
            {ImageSign}
            {Footer}
            {DrawSign}
        </div>
        <DialogActions>
            {CommonActions}
            {EditActions}
        </DialogActions>
    </Fragment>
  )
}